// extracted by mini-css-extract-plugin
module.exports = {"descriptionList":"DropdownWithDescription_descriptionList__j5eBy","isHidden":"DropdownWithDescription_isHidden__gHkjG"};